import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

import LocalInfo from './LocalInfo';
import MapInfoWindowNearestLocals from './MapInfoWindowNearestLocals';
import closeIcon from '../images/close.png';

export default ({
  local, nearestLocalsFromPoint, onClose, onSelectNearLocal,
}) => (
  <Container id="info-window">
    <CloseButton onClick={onClose}>
      <img src={closeIcon} alt="" width="15" />
    </CloseButton>

    <LocalInfo
      local={local}
    />

    {!local.abierto && (
      <MapInfoWindowNearestLocals
        locals={nearestLocalsFromPoint(local.coordenada, 50, 3, true)}
        onSelectNearLocal={onSelectNearLocal}
      />
    )}
  </Container>
);

const Container = styled.div`
  font-family: 'Roboto', sans-serif;
  margin-left: -17px;
  right: 8rem;
  top: 10px;
  ${tw`bg-white relative w-64 p-4 shadow-lg rounded z-50`}

  &:before {
    content: '';
    transform: rotate(135deg);
    box-shadow: -2px 2px 2px 0 rgba(178,178,178,.4);

    ${tw`
      h-5 w-5 bg-white
      absolute top-0 right-0 left-0 mx-auto -mt-2 z-40
    `}
  }
`;

const CloseButton = styled.button`
  ${tw`
    absolute top-0 right-0 cursor-pointer
    appearance-none border-none bg-transparent
    mt-2 mr-px
  `}
`;
